import CreateScheduleNotification from '../../../../../components/ScheduleNotification/CreateScheduleNotification/CreateScheduleNotification'

const CreateScheduleNotificationScreen = () => {
    return (
        <CreateScheduleNotification />
    )
}

export default CreateScheduleNotificationScreen